@use 'kci-design-lib/styles/variables.scss' as *;
.dropdown-container {
  font-family: $font-family;
  width: 100%;
  max-width: 100%;
  display: flex;
  align-items: center;
  [data-pc-name='dropdown'] {
    max-width: 100%;
    width: 100%;
    border: none;
    box-shadow: none;
    align-items: center;
    gap: 8px;
    background-color: transparent;
  }
  [data-pc-section='input'] {
    padding: 0;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0.2px;
    color: var(--header);
    display: inline-flex;
    font-family: $font-family;
    img {
      filter: unset;
    }
  }
  [data-pc-section='dropdownicon'] {
    width: 12px;
    height: 12px;
    filter: var(--dropdown-container-trigger-filter);
    path {
      fill: var(--header);
    }
  }
  [data-pc-section='trigger'] {
    width: 12px;
    height: 12px;
    filter: var(--dropdown-container-trigger-filter);
    &:hover {
      filter: var(--dropdown-container-trigger-filter-hover, var(--dropdown-container-trigger-filter));
    }
    &[aria-expanded='true'] {
      path {
        fill: var(--header);
      }
    }
  }
  &.flag-dropdown {
    [data-pc-section='trigger'] {
      display: none;
    }
    [data-pc-section='input'] {
      img {
        width: 32px;
        height: 32px;
        &[class*='flag'] {
          filter: none !important;
        }
      }
    }
  }
  .languageDropdown {
    display: flex;
    gap: 12px;
  }
}
.dropdown-panel {
  font-family: $font-family;
  &[data-pc-section='panel'] {
    width: 444px;
    border-radius: 0 0 0 8px;
    background: var(--dropdown-panel-bg);
    box-shadow: var(--dropdown-shadow);
    border: none;
    margin-top: 12px;
  }
  [data-pc-section='list'] {
    max-width: 100%;
    padding: 0;
  }
  [data-pc-section='item'] {
    max-width: 100%;
    position: relative;
    overflow: visible;
    min-height: 55px;
    max-height: 55px;
    &[role='option'] {
      padding: 0;
    }
    [data-pc-section='node'] {
      & > [data-pc-section='content'] {
        max-height: 55px;
        & > div {
          padding: 16px 18px 15px 19px;
          & > div {
            &:first-child {
              margin-right: 10px;
            }
          }
        }
        span {
          font-size: 16px;
          font-weight: 600;
          line-height: 24px;
          letter-spacing: 0.2px;
        }
        &:hover {
          span {
            color: var(--dropdown-hover-text);
          }
        }
      }
    }
    &:last-child {
      [data-pc-section='node'] {
        & > [data-pc-section='content'] {
          border: 0;
          border-bottom: 0;
        }
      }
      li {
        border: 0;
        border-bottom: 0;
      }
    }
    &[aria-selected='true'] {
      [data-pc-section='node'] {
        & > [data-pc-section='content'] {
          background-color: var(--dropdown-item-hover-bg);
          span {
            font-weight: 600;
            color: var(--dropdown-selected-text);
          }
        }
      }
      &:not(:last-child) {
        [data-pc-section='node'] {
          & > [data-pc-section='content'] {
            border-bottom: 1px solid var(--border-elevated);
          }
        }
      }
    }
    &:has(+ [aria-selected='true']) {
      [data-pc-section='node'] {
        & > [data-pc-section='content'] {
          border-bottom: 1px solid var(--border-elevated);
        }
      }
    }
  }
  &.p-dropdown-panel .p-dropdown-items .p-dropdown-item:hover,
  &.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-focus,
  [data-pc-section='item']:hover,
  [data-pc-section='item'].p-focus {
    background: var(--dropdown-item-hover-bg);
    [data-pc-name='tree'] [data-pc-section='content'] {
      background: var(--dropdown-item-hover-bg);
      border-bottom: var(--dropdown-hover-tree-border-bottom);
    }
  }
  [data-pc-section='itemlabel'] {
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  [data-pc-section='emptymessage'] {
    display: none;
  }
  [data-pc-section='loader'] {
    background-color: var(--surface-elevated);
  }
  [data-pc-name='virtualscroller'] {
    border-bottom-left-radius: 8px;
    height: unset !important; 
    min-height: 220px;
  }
  [data-testid='navlink-component'] {
    width: unset;
  }
  [data-pc-name='virtualscroller'],
  [data-pc-section='wrapper'] {
    max-height: calc(54.8px * 8) !important; 
    overflow-y: auto;
  }
  [data-pc-section='wrapper'] {
    border-radius: 0 0 0 8px;
  }
  &.flag-dropdown-panel {
    width: 240px;
    [data-pc-section='header'] {
      display: block;
      padding: 12px 8px;
    }
    [data-pc-section='item'] {
      min-height: 47px;
      outline: none;
      &:first-child {
        li {
          padding: 8px 4px;
          & > div {
            & > div {
              gap: 4px;
            }
          }
        }
        img {
          filter: var(--dropdown-flag-first-img-filter);
          &[class*='flag'] {
            filter: none !important;
          }
        }
      }
      &:not(:first-child) {
        li {
          padding: 12px 8px;
          & > div {
            & > div {
              gap: 8px;
            }
          }
        }
        img[class*='flag'] {
          filter: none !important;
        }
      }
      & > [data-pc-section='content'] {
        max-height: 47px;
      }
      li {
        width: 240px;
        height: 47px;
        padding: 11px;
        &:hover {
          background-color: var(--dropdown-item-hover-bg);
          div {
            color: var(--dropdown-hover-text);
          }
        }
      }
      &:not(:last-child) {
        li {
          border-bottom: 1px solid var(--dropdown-separator);
          &:hover {
            border-bottom: 1px solid var(--border-elevated);
          }
        }
      }
      &:last-child {
        li {
          border: 0;
          border-bottom: 0;
        }
      }
      &[aria-selected='true'] {
        &:not(:last-child) {
          li {
            border-bottom: 1px solid var(--border-elevated);
          }
        }
        li {
          background-color: var(--dropdown-item-hover-bg);
        }
        div {
          color: var(--dropdown-selected-text);
          font-weight: 600;
        }
      }
      &:has(+ [aria-selected='true']) {
        li {
          border-bottom: 1px solid var(--border-elevated);
        }
      }
    }
    div {
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.2px;
      height: unset;
      color: var(--dropdown-flag-div-color);
    }
    li {
      &[data-pc-section='node'] {
        padding: 0;
      }
    }
    [data-pc-section='node'] {
      [data-pc-section='content'] {
        max-height: 47px;
        & > div {
          max-height: 47px;
        }
        span {
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.2px;
        }
      }
    }
    [data-pc-section='itemlabel'] {
      height: 47px;
    }
    [data-pc-name='virtualscroller'] {
      min-height: 188px;
    }
    &[data-pc-section='panel'] {
      border-radius: 4px;
      border: var(--dropdown-flag-panel-border);
    }
    [data-pc-section='wrapper'] {
      border-radius: 0 0 4px 4px;
    }
    [data-pc-name='virtualscroller'],
    [data-pc-section='wrapper'] {
      max-height: calc(46.8px * 8) !important; 
      overflow-y: auto;
    }
  }
  & > [data-pc-section='header'] {
    background: var(--dropdown-panel-bg);
    border-bottom: 1px solid var(--dropdown-border-subtle);
    padding: 14px 20px;
    [data-pc-section='filtercontainer'] {
      img {
        filter: var(--filter-icon-neutral);
      }
    }
  }
  &:not(.flag-dropdown-panel) {
    & > [data-pc-section='header'] {
      display: block;
    }
  }
  [data-pc-section='filterinput'] {
    border: none;
    padding: 0 0 0 24px;
    box-shadow: none;
    background: none;
    color: var(--dropdown-filter-color);
    & + div {
      position: absolute;
      top: 2px;
    }
  }
  [data-pc-section='filtericon'] {
    left: 0;
  }
  [data-button-type='tertiary'] {
    background: none;
    border: none;
  }
  &.p-dropdown-panel .p-dropdown-items .p-dropdown-item [data-button-type='tertiary'] img[alt='Heart'],
  [data-pc-section='item'] [data-button-type='tertiary'] img[alt='Heart'] {
    filter: var(--dropdown-heart-icon-filter);
  }
  &.p-dropdown-panel .p-dropdown-items .p-dropdown-item[aria-selected='true'] [data-button-type='tertiary'] img[alt='Heart'],
  [data-pc-section='item'][aria-selected='true'] [data-button-type='tertiary'] img[alt='Heart'] {
    filter: var(--dropdown-heart-active-filter);
  }
  &.noFavorites {
    width: 446px;
    border-radius: 4px;
    box-shadow: $elevation-level3-grey2;
    [data-pc-section='node'] {
      & > [data-pc-section='content'] {
        & > div {
          & > div {
            &:last-child {
              display: none;
            }
          }
        }
        span {
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
    .checkIcon {
      position: absolute;
      right: 18px;
      top: 14px;
      width: 18px;
      height: 18px;
      background-image: url('../../../../assets/Icons/Library/Check_outline.svg');
      filter: var(--dropdown-check-icon-filter, none);
    }
    [data-pc-section='item'] {
      min-height: 44px;
      max-height: 44px;
      [data-pc-section='node'] {
        & > [data-pc-section='content'] {
          max-height: 44px;
          & > div {
            padding: 12px 16px;
            max-height: 44px;
          }
        }
      }
    }
  }
  [data-pc-name='tree'] {
    border-radius: 0px;
  }
}

.customFeedbackFooter {
  padding: 0 12px 8px;
  background: var(--dropdown-panel-bg);
}

.customFeedbackInput {
  width: 100%;
  min-height: 38px;
  padding: 8px 0;
  border: 0;
  border-top: 1px solid var(--dropdown-separator);
  border-radius: 0;
  outline: 0;
  background: transparent;
  color: var(--header);
  font: inherit;
  box-sizing: border-box;

  &::placeholder {
    color: #b2b2b2;
    opacity: 1;
  }
}
[data-theme='dark'] {
  .dropdown-container {
    [data-pc-section='input'] {
      &[class~='p-placeholder'] {
        color: #b2b2b2;
      }
    }
    &.flag-dropdown {
      [alt='Browser'] {
        filter: brightness(0) invert(1);
      }
    }
  }
  .dropdown-panel {
    --navlink-hover-text: #def7ff;
    [data-pc-section='node'] > [data-pc-section='content'] span {
      color: #b2b2b2;
    }
    [data-pc-section='item']:hover [data-pc-section='node'] > [data-pc-section='content'] span,
    [data-pc-section='item'].p-focus [data-pc-section='node'] > [data-pc-section='content'] span,
    [data-pc-section='item'][aria-selected='true'] [data-pc-section='node'] > [data-pc-section='content'] span {
      color:var(--dropdown-hover-text) !important;
    }
    [data-pc-section='item'] [data-button-type='tertiary'] img {
      filter: brightness(0) saturate(100%) invert(93%) sepia(5%) saturate(17%) hue-rotate(323deg) brightness(78%) contrast(86%);
    }
    [data-pc-section='item']:hover [data-button-type='tertiary'] img,
    [data-pc-section='item'].p-focus [data-button-type='tertiary'] img,
    [data-pc-section='item'][aria-selected='true'] [data-button-type='tertiary'] img {
      filter: brightness(0) saturate(100%) invert(88%) sepia(75%) saturate(6338%) hue-rotate(175deg) brightness(111%) contrast(104%) !important;
    }
  }
}
